import { render, staticRenderFns } from "./labelAlign-editor.vue?vue&type=template&id=1325a33c&scoped=true"
import script from "./labelAlign-editor.vue?vue&type=script&lang=js"
export * from "./labelAlign-editor.vue?vue&type=script&lang=js"
import style0 from "./labelAlign-editor.vue?vue&type=style&index=0&id=1325a33c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325a33c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1325a33c')) {
      api.createRecord('1325a33c', component.options)
    } else {
      api.reload('1325a33c', component.options)
    }
    module.hot.accept("./labelAlign-editor.vue?vue&type=template&id=1325a33c&scoped=true", function () {
      api.rerender('1325a33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/labelAlign-editor.vue"
export default component.exports